export const PRODUCTION_MODE = process.env.NODE_ENV === "production";

const host = window.location.host;
const localHTTP = `http://${host}/graphql/`;
// const localHTTP = "https://api.book.staging.asobi.market/graphql/";

export const BACKEND_HTTP_URI =
  process.env.VUE_APP_BACKEND_PRODUCTION_HTTP_URI || localHTTP;

export const BACKEND_WS_URI =
  process.env.VUE_APP_BACKEND_PRODUCTION_WS_URI || `ws://${host}/graphql/`;

export function getBackendHostAndPort() {
  return { BACKEND_HTTP_URI, BACKEND_WS_URI };
}

export const JWT_NAME = "jwt";
export const JWT_REFRESH_INTERVAL = 20;

export const ASOBICOIN_NETWORK_ID = process.env.VUE_APP_ASOBICOIN_NETWORK_ID;
export const ASOBICOIN_CONTRACT = process.env.VUE_APP_ASOBICOIN_CONTRACT;

export const TRANSACTION_CONFIRMATIONS_NUMBER = 3;
export const DEPOSIT_TRANSACTION_LOCALSTORAGE_KEY =
  "pendingDepositTransaction";

export const GA_TRACKING_ID =
  process.env.VUE_APP_GA_TRACKING_ID || "UA-135691904-2";
export const DEPOSIT_TRANSACTION_TIMEOUT = 1200000; // 20 min in ms

export const DEFAULT_GQL_PAGE_SIZE = 1000;

// License chain
const defaultChainURL = "https://ethereum.lab.asobimo.io/rpc";
const defaultContractAddress = "0x9d6B8BE5ca3bCb893d4EF9Ff5429a8cBb8ac270f";
export const LICENSE_CHAIN_URL =
  process.env.VUE_APP_LICENSE_CHAIN_URL || defaultChainURL;
export const LICENSE_CONTRACT_ADDRESS =
  process.env.VUE_APP_LICENSE_CONTRACT_ADDRESS || defaultContractAddress;

export const USER_PROFILE_LOCALSOTORAGE_KEY = "USER_PROFILE";
export const CHARGE_NEXT_ROUTE_LOCALSOTORAGE_KEY = "CHARGE_NEXT_ROUTE";

export const DSS_URL =
  process.env.VUE_APP_DSS_URL || "https://test.ds-system.io/en/#exchange";

export const DSS_URL_FOR_ASOBIWALLET =
  process.env.VUE_APP_DSS_URL_FOR_ASOBIWALLET ||
  "https://test.ds-system.io/exchange/";

export const BUILD_TARGET = process.env.VUE_APP_TARGET || "ASOBI_MARKET";

export enum AppType {
  games = "games",
  books = "books",
}

const targetConfigs = {
  // This is the production environment configuration
  ASOBI_MARKET: {
    enabledApps: [AppType.games, AppType.books],
    enableChargeByCreditCard: true,
    enableChargeByIAP: true,
    enableBatching: true,
  },
  REFERRAL_MARKET: {
    enabledApps: [AppType.games],
    enableChargeByCreditCard: false,
    enableChargeByIAP: false,
    enabledReferral: true,
    enableBatching: false,
  },
  // This is what we have on test.asobi.market as of 2019-09-06
  BOOKS_MARKET: {
    enabledApps: [AppType.games, AppType.books],
    enableChargeByCreditCard: true,
    enableChargeByIAP: true,
    enableBatching: true,
  },
  // This is what we use for testing the DiSEL APP
  NO_GAMES_MARKET: {
    enabledApps: [AppType.books],
    enableChargeByCreditCard: true,
    enableChargeByIAP: true,
    enableBatching: true,
  },
  BOOK_VIEWER: {
    enabledApps: [AppType.books],
    enableChargeByCreditCard: true,
    enableChargeByIAP: false,
    enableBatching: false,
  },
  // This is the configuration for DS System
  EXCHANGE: {
    enabledApps: [AppType.games, AppType.books],
    enableChargeByCreditCard: true,
    enableChargeByIAP: false,
    enableBatching: false,
  },
};

export const currentTargetConfig = targetConfigs[BUILD_TARGET];

export const appSlugs = currentTargetConfig.enabledApps;

export const SUPPORT_MAIL_ADDRESS = "support@disel.io";

export const ENABLE_BATCHING = currentTargetConfig.enableBatching;
export const BATCHING_INTERVAL = 50;
export const DISEL_HOME_URL = "disel://home";
